import useGoToNavigation from "../../../../../util/useGotoNavigation";
import React from "react";
import {UseFormRegister} from "react-hook-form";
import {useUser} from "../../../../../util/userContext/UserContext";
import {OrdersCreateType} from "../interface";

interface PropsType {
    watchCreateDetail: OrdersCreateType
    register: UseFormRegister<OrdersCreateType>
    btnSave: () => void
}

export default function Upper({watchCreateDetail, register, btnSave}: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser();

    const goToList = () => {
        goToNavigation(-1, {}, false)
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">수주 등록</h3>
            <div className="filter_toolbar">
                <button className="btn btn-outline-primary w-100px h-38px" onClick={goToList}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                </button>
                <button className="btn btn-primary w-100px h-38px" onClick={btnSave}>
                    등록
                </button>
            </div>
        </div>
        <h5 className="subheading">수주 정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>출하번호</th>
                    <td style={{width: "33.34%"}}>{watchCreateDetail.shipmentNo}</td>
                    <th style={{width: "16.66%"}}>상태</th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.newPProgress}
                                {...register("newPProgress")}>
                            <option value={100000000}>수주</option>
                            <option value={100000001}>출하요청</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>수주일자 <span className="required">*</span></th>
                    <td>{watchCreateDetail.newDtOrder}</td>
                    <th>요청자</th>
                    <td>{user?.userName}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}